import request from '@/util/request'

export async function generateVisaPayRecord(data) {
  return await request({
    url: '/pay/generateVisaPayRecord',
    method: 'post',
    data,
  })
}

export async function getNiuBizConfig(query) {
  return await request({
    url: '/pay/getNiuBizConfig',
    method: 'get',
    params: query,
  })
}
